import { useEffect, useState } from 'react';
import { App } from 'antd';
import { fetchDataSources } from '../../data/variablesDataApi';
import { t } from '../../utils';

export const useFetchDatasources = () => {
	const { notification } = App.useApp();
	const [isDatasourcesFetched, setIsDatasourcesFetched] = useState(false);
	const [dataSources, setDatasources] = useState([]);
	useEffect(() => {
		const onMount = async () => {
			try {
				const response = await fetchDataSources();
				const mappedDataSources = response.map(d => {
					const dataSourceOption: any = { ...d };
					dataSourceOption.label = d.connectionName;
					dataSourceOption.value = d.connectionRID;
					return dataSourceOption;
				});
				setDatasources(mappedDataSources);
				setIsDatasourcesFetched(true);
			} catch {
				notification.error({
					message: t('errorMessages.fetchDataSourcesError'),
				});
			}
		};

		onMount();
	}, [notification]);

	return { isDatasourcesFetched, dataSources };
};
